import { render } from "./LabeledRadio.vue?vue&type=template&id=23473723"
import script from "./LabeledRadio.vue?vue&type=script&lang=js"
export * from "./LabeledRadio.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./LabeledRadio.vue?vue&type=style&index=0&id=23473723&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script